import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  modalWrapper: {
    position: "fixed",
    inset: 0,
    zIndex: 9999,
    isolation: "isolate",
  },
  backdrop: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 9999,
    [theme.breakpoints.down("md")]: {
      backgroundColor: "rgba(0, 0, 0, 0.4)",
    },
  },
  modalContainer: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 10000,
    width: "min(28rem, 90vw)",
    [theme.breakpoints.down("md")]: {
      top: "40%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "90vw",
      maxWidth: "400px",
      maxHeight: "min(70vh, 500px)",
    },
  },
  modal: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(3),
    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.15)",
    padding: theme.spacing(5),
    paddingTop: theme.spacing(6),
    position: "relative",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    maxHeight: "100%",
    overflowY: "auto",
    zIndex: 10001,
    [theme.breakpoints.down("md")]: {
      borderRadius: theme.spacing(2.5),
      padding: theme.spacing(4),
      paddingTop: theme.spacing(5),
      gap: theme.spacing(2.5),
      "&::-webkit-scrollbar": {
        width: 0,
      },
    },
  },
  closeButton: {
    position: "absolute",
    top: theme.spacing(2.5),
    right: theme.spacing(2.5),
    width: 36,
    height: 36,
    borderRadius: "50%",
    border: "none",
    backgroundColor: "#f5f5f5",
    color: "#86868b",
    cursor: "pointer",
    display: "grid",
    placeItems: "center",
    transition: "all 0.2s",
    zIndex: 10002,
    "&:hover": {
      backgroundColor: "#e5e5e7",
      transform: "scale(1.05)",
    },
    [theme.breakpoints.down("md")]: {
      width: 32,
      height: 32,
      top: theme.spacing(2),
      right: theme.spacing(2),
    },
  },
  heading: {
    color: "#0A1A2F",
    textAlign: "center",
    fontWeight: 600,
    fontSize: "1.5rem",
    marginBottom: 0,
    [theme.breakpoints.down("md")]: {
      fontSize: "1.375rem",
    },
  },
  subheading: {
    textAlign: "center",
    color: "#86868b",
    fontSize: "0.875rem",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      fontSize: "0.875rem",
      marginBottom: theme.spacing(1),
    },
  },
  formContent: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    [theme.breakpoints.down("md")]: {
      gap: theme.spacing(2.5),
    },
  },
  checkboxGroup: {
    alignSelf: "center",
    marginBottom: 0,
  },
  checkbox: {
    padding: theme.spacing(0.5),
    marginRight: theme.spacing(1),
    color: "#d2d2d7",
    "&.Mui-checked": {
      color: theme.palette.secondary.main,
    },
  },
  checkboxLabel: {
    fontSize: "0.875rem",
    color: "#0A1A2F",
  },
  termsText: {
    textAlign: "center",
    color: "#86868b",
    lineHeight: 1.5,
    "& .MuiTypography-root": {
      fontSize: "0.75rem",
    },
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
      opacity: 0.8,
    },
  },
  authButtons: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    marginTop: theme.spacing(1),
    "& > *": {
      zIndex: 10002,
      position: "relative",
    },
  },
  facebookButton: {
    width: "100%",
    padding: theme.spacing(2),
    borderRadius: theme.spacing(3),
    fontSize: "0.875rem",
    fontWeight: 500,
    backgroundColor: "#1877F2",
    color: "white",
    border: "none",
    transition: "all 0.2s",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1.5),
    cursor: "pointer",
    zIndex: 10002,
    "&:hover": {
      backgroundColor: "#1664D8",
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(24, 119, 242, 0.3)",
    },
    "& svg": {
      fontSize: "1.25rem",
    },
  },
  googleButton: {
    width: "100%",
    padding: theme.spacing(2),
    borderRadius: theme.spacing(3),
    fontSize: "0.875rem",
    fontWeight: 500,
    backgroundColor: "white",
    color: "#0A1A2F",
    border: "1px solid #d2d2d7",
    transition: "all 0.2s",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1.5),
    cursor: "pointer",
    zIndex: 10002,
    "&:hover": {
      borderColor: "#86868b",
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    },
    "& img": {
      width: "1.25rem",
      height: "1.25rem",
    },
  },
}));
